module.exports = __webpack_public_path__ + "media/application/images/ui/icon-chevron-3a81d86a7bf2d6c45034f2d5c2045f66.png";